export const SubjectIcon = [
  {
    id: 0,
    subjectName: "Social and Political Science",
    icon: "/subIcon/ic_png_social_science.png",
  },
  {
    id: 1,
    subjectName: "Maths",
    icon: "/subIcon/ic_png_maths.png",
  },
  {
    id: 2,
    subjectName: "Geography",
    icon: "/subIcon/ic_png_geography.png",
  },
  {
    id: 3,
    subjectName: "Science",
    icon: "/subIcon/ic_png_science.png",
  },
  {
    id: 4,
    subjectName: "Physics",
    icon: "/subIcon/ic_png_physics.png",
  },
  {
    id: 5,
    subjectName: "Biology",
    icon: "/subIcon/ic_png_biology.png",
  },
  {
    id: 6,
    subjectName: "Chemistry",
    icon: "/subIcon/ic_png_chemistry.png",
  },
  {
    id: 7,
    subjectName: "Hindi",
    icon: "/subIcon/ic_png_hindi.png",
  },

  {
    id: 8,
    subjectName: "History",
    icon: "/subIcon/ic_png_history.png",
  },
  {
    id: 9,
    subjectName: "Kannada",
    icon: "/subIcon/ic_png_kannada.png",
  },
  {
    id: 10,
    subjectName: "Sanskrit",
    icon: "/subIcon/ic_png_sanskrit.png",
  },
  {
    id: 11,
    subjectName: "English",
    icon: "/subIcon/ic_png_english.png",
  },
  {
    id: 12,
    subjectName: "Statistics",
    icon: "/subIcon/ic_png_statistics.png",
  },
  {
    id: 13,
    subjectName: "Political Science",
    icon: "/subIcon/ic_png_political_science.png",
  },
  {
    id: 14,
    subjectName: "Environmental Studies",
    icon: "/subIcon/ic_png_evs.png",
  },
];
